import axios, { AxiosRequestConfig } from 'axios';
import { authService } from './AuthService';

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_URL || 'api/v1.0/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export interface ObjectLiteral {
  [key: string]: any;
}
export function getAuthorizationHeaders(): Promise<ObjectLiteral> {
  return authService.getUser().then(user => {
    return user
      ? {
          Authorization: `Bearer ${user.access_token}`
        }
      : {};
  });
}

apiClient.interceptors.request.use(function requestInterceptor(config: AxiosRequestConfig) {
  return getAuthorizationHeaders().then(headers => {
    Object.assign(config.headers, headers);
    return config;
  });
});
